import type { Locale } from "./config";

/** Prepend locale prefix to a path. */
export function localePath(locale: Locale, path: string): string {
	const clean = path.startsWith("/") ? path : `/${path}`;
	return `/${locale}${clean === "/" ? "" : clean}`;
}
